/**
 * Acceptance — a contact's acknowledgement of a policy or content item.
 * Derived from coreBOS `evAcceptance` (policies.evolutivo.ai). This is the
 * acceptance-tracking core that survives into the AI portal; GDPR consent-as-threat
 * framing is dropped in favour of plain acknowledgement.
 */
export const acceptanceDescriptor = {
    slug: 'acceptance',
    kind: 'document',
    label: { singular: 'Accettazione', plural: 'Accettazioni' },
    table: 'ai_portal_acceptance',
    idStrategy: 'sha256',
    fields: [
        { name: 'acctitle', type: 'text', label: 'Titolo', required: true },
        { name: 'acceptance_status', type: 'text', label: 'Stato' },
        { name: 'acclastdate', type: 'date', label: 'Data' },
        { name: 'accmethod', type: 'text', label: 'Metodo' },
        { name: 'acclevelescal', type: 'text', label: 'Livello Escalation' },
        { name: 'email_opened', type: 'boolean', label: 'Email Aperta' },
        { name: 'contact_type', type: 'text', label: 'Tipo Contatto' },
        { name: 'evacceptance_no', type: 'text', label: 'Numero' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [
        { name: 'acctopolicy', kind: 'belongsTo', target: 'policy' },
        { name: 'acceptancetocontent', kind: 'belongsTo', target: 'content' },
        { name: 'pacclinktocontact', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'acctoemployee', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        numbering: { prefix: 'ACC', seq: 'ai_portal_acceptance_no' },
        tenantScoped: true,
    },
    emits: ['acceptance.created', 'acceptance.updated', 'acceptance.acknowledged'],
    ui: { mode: 'generated', icon: 'CheckCircleOutlined', navGroup: 'Compliance', navOrder: 11 },
};
